<template>
  <section
    class="cn-rich-advantages"
    :class="{
      'cn-rich-advantages--inverted': inverted,
    }"
  >
    <div class="container">
      <div class="cn-rich-advantages__content">
        <div class="cn-rich-advantages__left">
          <div class="cn-rich-advantages__text">
            <h2 class="cn-rich-advantages__title">
              {{ data.heading }}
            </h2>
            <UiList v-if="textToList.length > 1" :items="textToList" />
            <p v-else>{{ textToList[0] }}</p>
          </div>
        </div>
        <div class="cn-rich-advantages__right">
          <CdnImg :src="data.image.path" format="webp" loading="lazy" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import { computed } from 'vue';
import UiList from '@/components/ui/UiList';

// TODO: fix type
interface Props {
  data: any;
  inverted?: boolean;
}
const props = defineProps<Props>();

const textToList = computed(() => {
  if (Array.isArray(props.data.text)) return props.data.text;
  const arrayOfText = props.data.text.split('\r\n');
  const arrayOfTextTrimed = arrayOfText.filter((n: any) => n);
  return arrayOfTextTrimed;
});
</script>

<style lang="scss">
.cn-rich-advantages {
  --cn-rich-advantages-title-color-text: var(--ab-canyon-color-dark);

  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);
  @media (min-width: 1280px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  &__content {
    row-gap: var(--size-lg);
    align-items: center;
    flex-wrap: wrap;
    display: flex;
  }
  &__left {
    width: 100%;
    @media (min-width: 1280px) {
      width: 41.666667%;
    }
  }
  &__title {
    color: var(--cn-rich-advantages-title-color-text);
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 700;
    text-transform: uppercase;

    @media (min-width: 640px) {
      margin-bottom: 0.5rem;
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
  &__right {
    width: 100%;
    @media (min-width: 1280px) {
      width: 58.333333%;
    }

    img {
      object-fit: cover;
      width: 100%;
      @media (min-width: 1280px) {
        height: 428px;
      }
    }
  }

  &:not(.cn-rich-advantages--inverted) {
    .cn-rich-advantages {
      &__right {
        @media (min-width: 1280px) {
          padding-left: var(--size-5xl);
        }
      }
    }
  }
  &--inverted {
    .cn-rich-advantages {
      &__text {
        @media (min-width: 1280px) {
          padding-left: var(--size-3xl);
        }
      }
      &__right {
        @media (min-width: 1280px) {
          padding-right: var(--size-5xl);
          order: -9999;
        }
      }
    }
  }
}
</style>
